import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8465 5.1718L14.2241 6.85781L12.618 7.73595L14.3582 8.33737L15.2738 9.88752L15.8906 8.20792L17.5022 7.32338L15.7565 6.72837M8.90152 7.45591L7.669 10.8269L4.44469 12.5842L7.93607 13.7742L9.75614 16.8874L10.9887 13.5164L14.213 11.7591L10.7216 10.569M15.5942 13.4243L14.9713 15.1044L13.3658 15.9885L15.1054 16.584L16.0216 18.14L16.6378 16.4545L18.25 15.5759L16.5037 14.975",
			fill: "url(#paint0_linear_400_14527)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.96077 2.28158C7.40505 0.51115 10.4267 -0.273255 13.4235 0.0847576C16.4203 0.442774 19.1722 1.91691 21.1306 4.21331C23.089 6.50971 24.1102 9.45977 23.9906 12.4755C23.871 15.4912 22.6194 18.3511 20.4853 20.4852L18.4533 18.4532C20.1048 16.8017 21.1263 14.5201 21.1263 12C21.1262 6.95976 17.0403 2.87382 12.0001 2.87381C6.9598 2.87381 2.87386 6.95976 2.87385 12C2.87385 17.0402 6.95979 21.1262 12.0001 21.1262C13.4827 21.1262 14.8826 20.7725 16.1204 20.1451L17.4168 22.7079C14.7236 24.0702 11.616 24.3678 8.71335 23.5411C5.81065 22.7145 3.32602 20.8244 1.75469 18.2476C0.183357 15.6708 -0.359302 12.5965 0.23489 9.63751C0.829084 6.67849 2.51649 4.05201 4.96077 2.28158Z",
			fill: "url(#paint1_linear_400_14527)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_400_14527",
			x1: 2.27504e-7,
			y1: 14.8723,
			x2: 7.02128,
			y2: 24,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1BC8FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#9789FF"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_400_14527",
			x1: 2.27504e-7,
			y1: 14.8723,
			x2: 7.02128,
			y2: 24,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1BC8FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#9789FF"
			})]
		})] })
	]
});
export default SvgAiLogo;
